import { render, staticRenderFns } from "./QuestionnaireCard.vue?vue&type=template&id=f30d7cca&scoped=true&"
import script from "./QuestionnaireCard.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireCard.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireCard.vue?vue&type=style&index=0&id=f30d7cca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30d7cca",
  null
  
)

export default component.exports